export const ROLES = {
  UTENTE_BASE: "utente_base",
  GESTORE: "gestore",
  ADMIN: "admin",
  SUPERADMIN: "superadmin",
};

const LEVEL = {
  utente_base: 1,
  gestore: 2,
  admin: 3,
  superadmin: 4,
};

export const ROLE_LABELS = {
  utente_base: "Utente",
  gestore: "Gestore",
  admin: "Admin",
  superadmin: "Super Admin",
};

export function getRole(loginStatus) {
  return loginStatus?.platform_role || (loginStatus?.is_admin ? ROLES.ADMIN : ROLES.UTENTE_BASE);
}

export function hasMinRole(loginStatus, minimumRole) {
  const current = LEVEL[getRole(loginStatus)] || 1;
  const required = LEVEL[minimumRole] || 1;
  return current >= required;
}

export function canAccessDashboard(loginStatus) {
  const role = getRole(loginStatus);
  return role !== ROLES.UTENTE_BASE;
}

export function canAccessPlatformReservedArea(loginStatus) {
  const role = getRole(loginStatus);
  return role === ROLES.ADMIN || role === ROLES.SUPERADMIN;
}

export function shouldRejectPlatformLogin(appSlug, loginStatus) {
  if (appSlug) return false;
  return !canAccessPlatformReservedArea(loginStatus);
}

export const PLATFORM_LOGIN_UNAUTHORIZED =
  "Non disponi dell'autorizzazione per accedere all'area riservata.";

export function getDashboardMenu(loginStatus) {
  const role = getRole(loginStatus);

  const applicazioni = { key: "applicazioni", label: "Applicazioni", path: "/dashboard/applicazioni" };
  const gestori = { key: "gestori", label: "Gestori", path: "/dashboard/gestori" };
  const eventi = { key: "eventi", label: "Eventi", path: "/dashboard/eventi" };
  const iniziaEventi = { key: "inizia-eventi", label: "Inizia evento", path: "/dashboard/inizia-eventi" };
  const terminaEventi = { key: "termina-eventi", label: "Termina evento", path: "/dashboard/termina-eventi" };
  const iscrizioni = { key: "iscrizioni", label: "Iscrizioni", path: "/dashboard/iscrizioni" };
  const sondaggi = { key: "sondaggi", label: "Sondaggi", path: "/dashboard/sondaggi" };
  const chatEventi = { key: "chat-evento", label: "Chat evento", path: "/dashboard/chat-evento" };
  const utenti = { key: "utenti", label: "Utenti", path: "/dashboard/utenti" };
  const profilo = { key: "profilo", label: "Il mio profilo", path: "/dashboard/profilo" };

  if (role === ROLES.SUPERADMIN) {
    return [applicazioni, gestori, eventi, iniziaEventi, terminaEventi, sondaggi, chatEventi, utenti, profilo];
  }

  if (role === ROLES.ADMIN) {
    return [applicazioni, gestori, utenti, profilo];
  }

  if (role === ROLES.GESTORE) {
    return [eventi, iniziaEventi, terminaEventi, sondaggi, chatEventi, iscrizioni, profilo];
  }

  return [];
}

export function getDashboardHomePath(loginStatus) {
  const role = getRole(loginStatus);
  if (role === ROLES.ADMIN) return "/dashboard/applicazioni";
  if (role === ROLES.GESTORE) return "/dashboard/eventi";
  if (role === ROLES.SUPERADMIN) return "/dashboard/applicazioni";
  return "/";
}

export function getPostLoginPath(loginStatus, appSlug) {
  const role = getRole(loginStatus);
  if (role === ROLES.UTENTE_BASE) {
    const slug = appSlug || loginStatus?.application_slug;
    return slug ? `/${slug}` : "/";
  }
  return getDashboardHomePath(loginStatus);
}

export function getReservedAreaPath(loginStatus) {
  if (canAccessDashboard(loginStatus)) {
    return getDashboardHomePath(loginStatus);
  }
  return "/login";
}
